import { render, staticRenderFns } from "./CustomTableRow.vue?vue&type=template&id=0a0e0764&"
import script from "./CustomTableRow.vue?vue&type=script&lang=js&"
export * from "./CustomTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports